import React from "react";
import ReactDOM from "react-dom";
import { MdClose } from "react-icons/md";

const Tooltip = ({ content, position, closeButton, onClose, onMouseEnter, onMouseLeave }) => {
  if (!content) return null;

  const style = {
    position: "absolute" as const,
    top: position.top,
    left: position.left,
    transform: "translate(-50%, -100%)",
    background: "white",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "fit-content",
    zIndex: 99999,
  };

  return ReactDOM.createPortal(
    <div
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div>
        {closeButton && (
          <button
            style={{
              background: "transparent",
              position: "absolute",
              border: "none",
              top: "0",
              right: "0",
            }}
            onClick={onClose}
          >
            <MdClose />
          </button>
        )}
        {content}
      </div>
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderStyle: "solid",
          borderWidth: "8px 8px 0 8px",
          borderColor: "white transparent transparent transparent",
        }}
      />
    </div>,
    document.body
  );
};

export default Tooltip;
